import { __spreadArray } from "tslib";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref } from "vue";
import _imports_0 from '@/assets/logo.png';
var _hoisted_1 = { class: "navbar" };
var _hoisted_2 = { class: "navbar-container" };
var _hoisted_3 = { class: "navbar-header" };
var _hoisted_4 = { class: "navbar-links navbar-links-desktop" };
var _hoisted_5 = {
    class: "navbar-link user-menu-trigger",
    href: "javascript:void(0)"
};
var _hoisted_6 = { class: "user-avatar-mini" };
var _hoisted_7 = { class: "user-menu-name" };
var _hoisted_8 = { class: "user-menu-content" };
var _hoisted_9 = { class: "user-info-panel" };
var _hoisted_10 = { class: "user-avatar-large" };
var _hoisted_11 = { class: "user-info-text" };
var _hoisted_12 = { class: "user-name" };
var _hoisted_13 = { class: "user-points" };
var _hoisted_14 = { class: "user-menu-list" };
var _hoisted_15 = { class: "navbar-mobile-dropdown" };
var _hoisted_16 = {
    class: "mobile-menu-btn",
    "aria-label": "导航菜单"
};
import { computed, ref, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { ROLE_ADMIN } from '@/constants/enums';
import { Menu } from '@element-plus/icons-vue';
var BREAKPOINT = 768;
export default /*@__PURE__*/ _defineComponent({
    __name: 'NavBar',
    setup: function (__props) {
        var store = useStore();
        var router = useRouter();
        var isAuthenticated = computed(function () { return store.getters.isAuthenticated; });
        var isAdmin = computed(function () { return store.getters.hasRole(ROLE_ADMIN); });
        // ==================== 用户菜单 ====================
        var userMenuVisible = ref(false);
        var displayName = computed(function () { return store.getters.getUsername || ''; });
        var availablePoints = computed(function () { var _a; return (_a = store.getters.getAvailablePoints) !== null && _a !== void 0 ? _a : 0; });
        var avatarLetter = computed(function () {
            var name = displayName.value;
            return name ? name.charAt(0).toUpperCase() : '?';
        });
        var goTo = function (path) {
            userMenuVisible.value = false;
            router.push(path);
        };
        // ==================== 移动端下拉菜单 ====================
        var mobileDropdownVisible = ref(false);
        var autoHideDropdown = function () {
            if (window.innerWidth > BREAKPOINT && mobileDropdownVisible.value) {
                mobileDropdownVisible.value = false;
            }
        };
        var mql = null;
        onMounted(function () {
            mql = window.matchMedia("(min-width: ".concat(BREAKPOINT + 1, "px)"));
            autoHideDropdown();
            var handleMqlChange = function (e) {
                if (e.matches) {
                    mobileDropdownVisible.value = false;
                }
            };
            mql.addEventListener('change', handleMqlChange);
            window.addEventListener('resize', autoHideDropdown);
        });
        onUnmounted(function () {
            if (mql) {
                mql.removeEventListener('change', function () { });
            }
            window.removeEventListener('resize', autoHideDropdown);
        });
        // ==================== 登出 ====================
        var handleLogout = function () {
            userMenuVisible.value = false;
            store.commit('CLEAR_AUTH');
            if (router.hasRoute('admin')) {
                router.removeRoute('admin');
            }
            router.push('/');
        };
        return function (_ctx, _cache) {
            var _component_router_link = _resolveComponent("router-link");
            var _component_el_dropdown = _resolveComponent("el-dropdown");
            var _component_el_icon = _resolveComponent("el-icon");
            var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
            var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
            return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_router_link, {
                            class: "navbar-brand",
                            to: "/"
                        }, {
                            default: _withCtx(function () { return __spreadArray([], (_cache[17] || (_cache[17] = [
                                _createElementVNode("img", {
                                    class: "navbar-logo",
                                    src: _imports_0,
                                    alt: "Logo"
                                }, null, -1),
                                _createTextVNode(" 栽桃圣母的桃园 ", -1)
                            ])), true); }),
                            _: 1
                        })
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_router_link, {
                            class: "navbar-link",
                            to: "/talent"
                        }, {
                            default: _withCtx(function () { return __spreadArray([], (_cache[18] || (_cache[18] = [
                                _createTextVNode("才艺单", -1)
                            ])), true); }),
                            _: 1
                        }),
                        _createVNode(_component_router_link, {
                            class: "navbar-link",
                            to: "/schedule"
                        }, {
                            default: _withCtx(function () { return __spreadArray([], (_cache[19] || (_cache[19] = [
                                _createTextVNode("日程", -1)
                            ])), true); }),
                            _: 1
                        }),
                        _createVNode(_component_router_link, {
                            class: "navbar-link",
                            to: "/marshmallows"
                        }, {
                            default: _withCtx(function () { return __spreadArray([], (_cache[20] || (_cache[20] = [
                                _createTextVNode("棉花糖", -1)
                            ])), true); }),
                            _: 1
                        }),
                        (isAuthenticated.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_router_link, {
                                    class: "navbar-link",
                                    to: "/pointGift"
                                }, {
                                    default: _withCtx(function () { return __spreadArray([], (_cache[21] || (_cache[21] = [
                                        _createTextVNode("积分礼物", -1)
                                    ])), true); }),
                                    _: 1
                                }),
                                (isAdmin.value)
                                    ? (_openBlock(), _createBlock(_component_router_link, {
                                        key: 0,
                                        class: "navbar-link",
                                        to: "/admin"
                                    }, {
                                        default: _withCtx(function () { return __spreadArray([], (_cache[22] || (_cache[22] = [
                                            _createTextVNode("管理后台", -1)
                                        ])), true); }),
                                        _: 1
                                    }))
                                    : _createCommentVNode("", true),
                                _createVNode(_component_el_dropdown, {
                                    trigger: "hover",
                                    visible: userMenuVisible.value,
                                    "onUpdate:visible": _cache[4] || (_cache[4] = function ($event) { return ((userMenuVisible).value = $event); }),
                                    "popper-class": "user-menu-popper",
                                    placement: "bottom-end",
                                    "show-timeout": 100,
                                    "hide-timeout": 200
                                }, {
                                    dropdown: _withCtx(function () { return [
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("span", null, _toDisplayString(avatarLetter.value), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_11, [
                                                    _createElementVNode("div", _hoisted_12, _toDisplayString(displayName.value), 1),
                                                    _createElementVNode("div", _hoisted_13, "可用积分：" + _toDisplayString(availablePoints.value.toLocaleString()), 1)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_14, [
                                                _createElementVNode("div", {
                                                    class: "user-menu-item",
                                                    onClick: _cache[0] || (_cache[0] = function ($event) { return (goTo('/profile')); })
                                                }, "👤 个人资料"),
                                                _createElementVNode("div", {
                                                    class: "user-menu-item",
                                                    onClick: _cache[1] || (_cache[1] = function ($event) { return (goTo('/wallet')); })
                                                }, "💰 我的钱包"),
                                                _createElementVNode("div", {
                                                    class: "user-menu-item",
                                                    onClick: _cache[2] || (_cache[2] = function ($event) { return (goTo('/orders')); })
                                                }, "📦 我的订单"),
                                                _createElementVNode("div", {
                                                    class: "user-menu-item",
                                                    onClick: _cache[3] || (_cache[3] = function ($event) { return (goTo('/userBotTask')); })
                                                }, "📬 弹幕任务")
                                            ]),
                                            _createElementVNode("div", { class: "user-menu-list" }, [
                                                _createElementVNode("div", {
                                                    class: "user-menu-item user-menu-item-danger",
                                                    onClick: handleLogout
                                                }, " 🚪 退出登录 ")
                                            ])
                                        ])
                                    ]; }),
                                    default: _withCtx(function () { return [
                                        _createElementVNode("a", _hoisted_5, [
                                            _createElementVNode("div", _hoisted_6, [
                                                _createElementVNode("span", null, _toDisplayString(avatarLetter.value), 1)
                                            ]),
                                            _createElementVNode("span", _hoisted_7, _toDisplayString(displayName.value), 1)
                                        ])
                                    ]; }),
                                    _: 1
                                }, 8, ["visible"])
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createVNode(_component_router_link, {
                                    class: "navbar-link",
                                    to: "/login"
                                }, {
                                    default: _withCtx(function () { return __spreadArray([], (_cache[23] || (_cache[23] = [
                                        _createTextVNode("登录", -1)
                                    ])), true); }),
                                    _: 1
                                }),
                                _createVNode(_component_router_link, {
                                    class: "navbar-link",
                                    to: "/register"
                                }, {
                                    default: _withCtx(function () { return __spreadArray([], (_cache[24] || (_cache[24] = [
                                        _createTextVNode("注册", -1)
                                    ])), true); }),
                                    _: 1
                                })
                            ], 64))
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_el_dropdown, {
                            trigger: "click",
                            placement: "bottom-end",
                            "popper-class": "mobile-nav-dropdown",
                            visible: mobileDropdownVisible.value,
                            "onUpdate:visible": _cache[16] || (_cache[16] = function ($event) { return ((mobileDropdownVisible).value = $event); })
                        }, {
                            dropdown: _withCtx(function () { return [
                                _createVNode(_component_el_dropdown_menu, null, {
                                    default: _withCtx(function () { return [
                                        _createVNode(_component_el_dropdown_item, {
                                            onClick: _cache[5] || (_cache[5] = function ($event) { return (_unref(router).push('/talent')); })
                                        }, {
                                            default: _withCtx(function () { return __spreadArray([], (_cache[25] || (_cache[25] = [
                                                _createTextVNode("🎵 才艺单", -1)
                                            ])), true); }),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            onClick: _cache[6] || (_cache[6] = function ($event) { return (_unref(router).push('/schedule')); })
                                        }, {
                                            default: _withCtx(function () { return __spreadArray([], (_cache[26] || (_cache[26] = [
                                                _createTextVNode("📅 日程", -1)
                                            ])), true); }),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_dropdown_item, {
                                            onClick: _cache[7] || (_cache[7] = function ($event) { return (_unref(router).push('/marshmallows')); })
                                        }, {
                                            default: _withCtx(function () { return __spreadArray([], (_cache[27] || (_cache[27] = [
                                                _createTextVNode("🍬 棉花糖", -1)
                                            ])), true); }),
                                            _: 1
                                        }),
                                        (isAuthenticated.value)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createVNode(_component_el_dropdown_item, {
                                                    divided: "",
                                                    onClick: _cache[8] || (_cache[8] = function ($event) { return (_unref(router).push('/pointGift')); })
                                                }, {
                                                    default: _withCtx(function () { return __spreadArray([], (_cache[28] || (_cache[28] = [
                                                        _createTextVNode("🎁 积分礼物", -1)
                                                    ])), true); }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_el_dropdown_item, {
                                                    onClick: _cache[9] || (_cache[9] = function ($event) { return (_unref(router).push('/profile')); })
                                                }, {
                                                    default: _withCtx(function () { return __spreadArray([], (_cache[29] || (_cache[29] = [
                                                        _createTextVNode("👤 个人资料", -1)
                                                    ])), true); }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_el_dropdown_item, {
                                                    onClick: _cache[10] || (_cache[10] = function ($event) { return (_unref(router).push('/wallet')); })
                                                }, {
                                                    default: _withCtx(function () { return __spreadArray([], (_cache[30] || (_cache[30] = [
                                                        _createTextVNode("💰 我的钱包", -1)
                                                    ])), true); }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_el_dropdown_item, {
                                                    onClick: _cache[11] || (_cache[11] = function ($event) { return (_unref(router).push('/orders')); })
                                                }, {
                                                    default: _withCtx(function () { return __spreadArray([], (_cache[31] || (_cache[31] = [
                                                        _createTextVNode("📦 我的订单", -1)
                                                    ])), true); }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_el_dropdown_item, {
                                                    onClick: _cache[12] || (_cache[12] = function ($event) { return (_unref(router).push('/userBotTask')); })
                                                }, {
                                                    default: _withCtx(function () { return __spreadArray([], (_cache[32] || (_cache[32] = [
                                                        _createTextVNode("📬 弹幕任务订阅", -1)
                                                    ])), true); }),
                                                    _: 1
                                                }),
                                                (isAdmin.value)
                                                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                                        key: 0,
                                                        onClick: _cache[13] || (_cache[13] = function ($event) { return (_unref(router).push('/admin')); })
                                                    }, {
                                                        default: _withCtx(function () { return __spreadArray([], (_cache[33] || (_cache[33] = [
                                                            _createTextVNode("⚙️ 管理后台", -1)
                                                        ])), true); }),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true),
                                                _createVNode(_component_el_dropdown_item, {
                                                    divided: "",
                                                    onClick: handleLogout
                                                }, {
                                                    default: _withCtx(function () { return __spreadArray([], (_cache[34] || (_cache[34] = [
                                                        _createElementVNode("span", { style: { "color": "#e74c3c" } }, "🚪 退出登录", -1)
                                                    ])), true); }),
                                                    _: 1
                                                })
                                            ], 64))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createVNode(_component_el_dropdown_item, {
                                                    divided: "",
                                                    onClick: _cache[14] || (_cache[14] = function ($event) { return (_unref(router).push('/login')); })
                                                }, {
                                                    default: _withCtx(function () { return __spreadArray([], (_cache[35] || (_cache[35] = [
                                                        _createTextVNode("🔑 登录", -1)
                                                    ])), true); }),
                                                    _: 1
                                                }),
                                                _createVNode(_component_el_dropdown_item, {
                                                    onClick: _cache[15] || (_cache[15] = function ($event) { return (_unref(router).push('/register')); })
                                                }, {
                                                    default: _withCtx(function () { return __spreadArray([], (_cache[36] || (_cache[36] = [
                                                        _createTextVNode("📝 注册", -1)
                                                    ])), true); }),
                                                    _: 1
                                                })
                                            ], 64))
                                    ]; }),
                                    _: 1
                                })
                            ]; }),
                            default: _withCtx(function () { return [
                                _createElementVNode("span", _hoisted_16, [
                                    _createVNode(_component_el_icon, { size: 22 }, {
                                        default: _withCtx(function () { return [
                                            _createVNode(_unref(Menu))
                                        ]; }),
                                        _: 1
                                    })
                                ])
                            ]; }),
                            _: 1
                        }, 8, ["visible"])
                    ])
                ])
            ]));
        };
    }
});
